import { useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { ensureLoaded } from '../../hooks/useFontFaceLoader.js';

export default function PreviewTab({ font, previewText, setPreviewText }) {
  const { theme } = useTheme();

  useEffect(() => {
    ensureLoaded(font);
  }, [font?.id]);

  return (
    <div>
      {/* Editable Preview */}
      <div style={{
        borderBottom: `1px solid ${theme.border}`,
        paddingBottom: 12, marginBottom: 20,
      }}>
        <input
          type="text"
          value={previewText}
          onChange={e => setPreviewText(e.target.value)}
          style={{
            width: '100%', background: 'none', border: 'none',
            fontFamily: `'${font.family}', serif`,
            fontSize: 28, color: theme.text, outline: 'none',
            fontWeight: 400, boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Weight Samples */}
      <div>
        <div style={{
          fontSize: 10, fontWeight: 600, color: theme.textFaint,
          marginBottom: 10, letterSpacing: '0.14em', textTransform: 'uppercase',
        }}>weights</div>
        {[300, 400, 500, 600, 700, 800].map(w => (
          <div key={w} style={{
            fontFamily: `'${font.family}', serif`,
            fontWeight: w, fontSize: 16,
            color: theme.textSecondary, padding: '6px 0',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            borderBottom: `1px solid ${theme.borderLight}`,
          }}>
            <span>Aa Bb Cc 123</span>
            <span style={{
              fontSize: 10, color: theme.textGhost,
              fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 500,
            }}>{w}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
